export class User {
	public _id: string
	public email: string
	public password: string
	public roles: Array<string>
	public companies: Array<any>
	public assignments: Array<string>
}

export class UserCreate {
	public _id?: string = ''
	public name: string = ''
	public cpf: string = ''
	public email: string = ''
	public telephone: string = ''
	public crea?: string = ''
	public jobTitle: string = ''
	public jobFunction: string = ''
	public companyId?: string = ''
	public roles: Array<string> = []
	public assignments: Array<string> = []
	public status?: string = ''
	public media_url: string = ''
	public companyServiceProvider: string
	public blocked: boolean = false
}

interface Location {
	lng: number
	lat: number
}

interface LocationRealTime {
	location: Location
	lastUpdatedAt: string // Date ISO 8601 format
}

type Role = 'INVENTOR' | 'EVALUATOR' | 'OPERATOR'

interface Information {
	app: 'Inventariante' | 'Avaliador' | 'Operador'
	lastActionMediaUrl: string
	lastActionDate: string // Date ISO 8601 format
	action: string
	lat: number
	lng: number
}

export interface UserLocationRealTime {
	cpf: string
	crea: string
	created_date: string // Date ISO 8601 format
	edit_date: string // Date ISO 8601 format
	term_accepted: string // Date ISO 8601 format
	email: string
	internetConnection: 'ONLINE' | 'OFFLINE'
	locationRealTime: LocationRealTime
	location: Location
	lat: number
	lng: number
	_id: string
	name: string
	information: Information
	roles: Array<Role>
	status: 'ACTIVE' | 'INACTIVE'
}

export interface IRoles {
	value: string
	name: string
}

export interface ICompanyServiceProvider {
	_id: string
	socialName: string
}
